import { useData } from "@hooks/useData";
import { components } from "@apiSchema";
import http from "@core/fetch";
import apiConfig from "@apiConfig";

type ChainSocialStatus = components['schemas']['ChainSocialStatusViewModel'];
type ChainSocialStatusWrapper = components['schemas']['ChainSocialStatusViewModelIReadOnlyListChainPermissionWrapper'];

const REQUEST_TYPE: keyof typeof apiConfig = 'get chains with social status';

// keywordTypeId = 3 = CHAINPROFILE
const CHAIN_PROFILE_TYPE = 3;

async function getChainsWithSocialActive(): Promise<ChainSocialStatus[]> {
    try {
        const response: ChainSocialStatusWrapper = await http.get(REQUEST_TYPE, {
            type: CHAIN_PROFILE_TYPE,
        });
        return response?.data ?? [];
    } catch (err) {
        console.error('Fetch error:', REQUEST_TYPE, err);
        return [];
    }
}

export function useChainsWithSocialActive() {
    return useData<ChainSocialStatus[]>([], getChainsWithSocialActive);
}
